import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight, X, ZoomIn, ZoomOut } from "lucide-react";
import { media } from "../lib/api";

export const Lightbox = ({ images, index, setIndex, onClose, name }) => {
  const [zoom, setZoom] = useState(false);
  const n = images.length;
  const go = (d) => { setZoom(false); setIndex((index + d + n) % n); };
  useEffect(() => {
    const key = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight" && n > 1) go(1);
      if (e.key === "ArrowLeft" && n > 1) go(-1);
    };
    window.addEventListener("keydown", key);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", key); document.body.style.overflow = prev; };
  }, [index]); // eslint-disable-line
  const btn = "grid h-11 w-11 place-items-center rounded-full bg-white/90 text-[#3E4436] shadow-lg transition-transform hover:scale-110";
  return createPortal(
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose}
      className="fixed inset-0 z-[200] flex flex-col bg-[#2B2F25]/95 backdrop-blur-md" data-testid="lightbox">
      <div className="flex items-center justify-between gap-3 p-4 text-white" onClick={(e) => e.stopPropagation()}>
        <p className="truncate text-sm" data-testid="lightbox-counter">{name} · {index + 1} / {n}</p>
        <div className="flex gap-2">
          <button className={btn} onClick={() => setZoom(!zoom)} aria-label="Přiblížit" data-testid="lightbox-zoom">{zoom ? <ZoomOut className="h-5 w-5" /> : <ZoomIn className="h-5 w-5" />}</button>
          <button className={btn} onClick={onClose} aria-label="Zavřít" data-testid="lightbox-close"><X className="h-5 w-5" /></button>
        </div>
      </div>
      <div className={`relative flex-1 ${zoom ? "overflow-auto" : "overflow-hidden"}`} onClick={(e) => e.stopPropagation()}>
        <AnimatePresence mode="wait">
          <motion.img key={index} src={media(images[index])} alt={name} initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0 }}
            onClick={() => setZoom(!zoom)} data-testid="lightbox-image"
            className={zoom ? "mx-auto max-w-none cursor-zoom-out" : "absolute inset-0 m-auto h-full w-full cursor-zoom-in object-contain p-2 sm:p-6"}
            style={zoom ? { width: "200%" } : undefined} />
        </AnimatePresence>
      </div>
      {n > 1 && (
        <div className="flex justify-center gap-4 p-4" onClick={(e) => e.stopPropagation()}>
          <button className={btn} onClick={() => go(-1)} aria-label="Předchozí" data-testid="lightbox-prev"><ChevronLeft className="h-5 w-5" /></button>
          <button className={btn} onClick={() => go(1)} aria-label="Další" data-testid="lightbox-next"><ChevronRight className="h-5 w-5" /></button>
        </div>
      )}
    </motion.div>,
    document.body
  );
};
